const MyPagination = {
  install(vue) {
    const firstButtonText = '처음';
    const prevButtonText = '이전';
    const nextButtonText = '다음';
    const lastButtonText = '끝';

    vue.prototype.$pagination = (currentPage, maxPostPage, maxPageGroup, totalCount) => {
      const totalPage = Math.ceil(totalCount / maxPostPage);
      const currentGroup = Math.floor(currentPage / maxPageGroup);
      const currentGroupFirstPage = currentGroup * maxPageGroup;
      const nextGroupFirstPage = currentGroupFirstPage + maxPageGroup;
      const prevGroupLastPage = currentGroupFirstPage - 1;
      const displayPageNumbers = [];

      for (let i = currentGroupFirstPage; i < nextGroupFirstPage; i += 1) {
        if (i >= totalPage) {
          break;
        }
        displayPageNumbers.push(i);
      }

      return {
        current: currentPage * 1,
        pages: displayPageNumbers,
        isValidButton: {
          first: currentPage > 0,
          prev: currentGroup > 0,
          next: nextGroupFirstPage < totalPage,
          last: currentPage < totalPage - 1,
        },
        buttonToLink: {
          first: 0,
          prev: prevGroupLastPage,
          next: nextGroupFirstPage,
          last: totalPage - 1,
        },
        buttonText: {
          first: firstButtonText,
          prev: prevButtonText,
          next: nextButtonText,
          last: lastButtonText,
        },
      };
    };
  },
};

export default MyPagination;



// WEBPACK FOOTER //
// ./src/plugins/my-pagination.js